import React from 'react';
import FormBarrio from '../../components/forms/formBarrio';

const NewBarrio = (props) => {
    return (<FormBarrio/>);
}
 
export default NewBarrio;